import React, { MouseEventHandler } from "react";
import { Button } from "@mui/material";
import useIsMobile from "components/hooks/useIsMobile";

export const NextStepButton: React.FC<{
  skippable?: boolean;
  hasValue?: boolean;
  disabled?: boolean;
  continueClick?: MouseEventHandler<HTMLButtonElement>;
  buttonText?: string;
  minWidth?: string | number;
  forcePrimary?: boolean;
}> = ({
  skippable = false,
  hasValue,
  disabled,
  continueClick,
  buttonText,
  minWidth,
  forcePrimary = false,
}) => {
  const isMobile = useIsMobile();
  const skipButton = !forcePrimary && !hasValue && skippable;

  return (
    <Button
      variant={!skipButton ? "contained" : "text"}
      color="primary"
      disabled={disabled || (!hasValue && !skippable)}
      onClick={continueClick}
      sx={{
        width: "auto",
        minWidth: skipButton ? "unset" : minWidth ?? "180px",
        bgcolor: !skipButton ? "#198282" : "transparent",
        color: !skipButton ? "white" : "#198282",
        "&:hover": {
          bgcolor: !skipButton ? "#276767" : "transparent",
        },
        "&.Mui-disabled": {
          backgroundColor: skipButton ? "transparent" : "#EAEBEC",
          color: skipButton ? "#9CA3AF" : undefined,
        },
        borderRadius: "32px",
        fontSize: skipButton ? "1rem" : "1.15rem",
        px: skipButton ? 1 : 4,
        py: skipButton ? 1 : undefined,
        textTransform: "none",
        boxShadow: isMobile ? "0px -1px 20px 5px rgba(255, 255, 255, .2)" : "",
      }}
    >
      {buttonText || (!skipButton || hasValue ? "Continue" : "Skip")}
    </Button>
  );
};
